import dayjs from 'dayjs'
import { Box } from '@mui/material'
import { Tag } from '../Tag'
import React from 'react'

import { IOrder } from '../../types/order'

interface Props {
  order: IOrder
}

const TelesaleTag = (props: Props) => {
  const { order } = props
  return (
    <>
      {order.isTelesale && (
        <Box py={0.5} display={'flex'} flexWrap={'wrap'} gap={1}>
          <Tag color={`success`}>
            Telesale{' '}
            {order.assignTelesaleBy ? `: ${order.assignTelesaleBy}` : ''}
          </Tag>
        </Box>
      )}
    </>
  )
}

export default TelesaleTag
